"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.join");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.string.split");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useResolveServiceActionName;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = require("react");

/**
 *
 * @param {Object} [options]
 * @param {Object} [options.action] Nazev akce z konfiguface. Vhodne pouzit pokud se nazev akce v `serviceActionName`
 *    nenachazi v `settings`. Napriklad pokud je `serviceActionName === 'v1.contacts.findByName'` a my chceme nastaveni
 *    pro `list`. Pokud neni definovano, pouzije se posledni fragment `serviceActionName`.
 * @param {Object} [options.omitActionName = false] Pokud je `true` z vysledku je vynechan nazev akce. Napriklad
 *    pokud je `serviceActionName === 'v1.contacts.findByName'` vysledkem bude `v1.contacts`
 * @param {Object} [options.settingsSelector] Selector do settings, pokud je odlisny od nazvu sluzby
 *    z `serviceActionName`.
 * @param {Object} [options.versionsDisabled = false] Pokud je `true` je `serviceActionName` bez verze a vysledek bude
 *    take bez verze.
 *
 * @param {string | Array<string>} serviceActionName Naze
 *
 * @param {{ [serviceName]: { version?: string, serviceName?: string, [action]?: string } }} [settings]
 *
 *
 * @returns {string} Nazev akce.
 */
function useResolveServiceActionName(options, serviceActionName, settings) {
  return (0, _react.useMemo)(function () {
    var _omitActionName$versi = (0, _extends2.default)({
      omitActionName: false,
      versionsDisabled: false
    }, options),
        pAction = _omitActionName$versi.action,
        omitActionName = _omitActionName$versi.omitActionName,
        pSettingsSelector = _omitActionName$versi.settingsSelector,
        versionsDisabled = _omitActionName$versi.versionsDisabled;

    var fragments = typeof serviceActionName === 'string' ? serviceActionName.split('.') : serviceActionName;
    var sanServiceName = fragments[versionsDisabled ? 0 : 1];
    var sanAction = fragments[versionsDisabled ? 1 : 2];
    var action = pAction || sanAction;
    var settingsSelector = pSettingsSelector || sanServiceName;

    var _ref = (settings || {})[settingsSelector] || {},
        serviceName = _ref.serviceName,
        version = _ref.version,
        actionName = _ref[action];

    return (Array.isArray(actionName) ? actionName : [versionsDisabled ? undefined : version || fragments[0], serviceName || sanServiceName, omitActionName ? undefined : actionName || sanAction || action].filter(Boolean)).join('.');
  }, [options, serviceActionName, settings]);
}